import COORDS from "./coords";
import { FORMAT } from "../libs/constants";
const toDEC = function (input) {
    if (!Array.isArray(input)) {
        throw new TypeError("input is not of type array");
    }
    return COORDS.convertBatch(input, FORMAT.DEC);
};
const toDMS = function (input) {
    if (!Array.isArray(input)) {
        throw new TypeError("input is not of type array");
    }
    return COORDS.convertBatch(input, FORMAT.DMS);
};
const toDDM = function (input) {
    if (!Array.isArray(input)) {
        throw new TypeError("input is not of type array");
    }
    return COORDS.convertBatch(input, FORMAT.DDM);
};
export { toDEC, toDMS, toDDM };
//# sourceMappingURL=conversion.js.map